const ROLE = [
    {
        value: 'inspectingcompany',
        label: 'Inspecting Company'
    },
    {
        value: 'shipoperator',
        label: 'Ship Operator'
    },
    {
        value: 'superadmin',
        label: 'Super Admin'
    },
    {
        value: 'adminfinance',
        label: 'Admin Finance'
    },
    {
        value: 'requestor',
        label: 'Requestor'
    }
];

export default ROLE;